import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import * as moment from "moment";
import {
  Badge,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Button,
  CardTitle
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Component
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
// FlatPickr
import "flatpickr/dist/themes/material_blue.css";
import FlatPickr from "react-flatpickr";

import {
  getProjects as onGetProjects,
  addNewProject as onAddNewProject,
  updateProject as onUpdateProject,
  deleteProject as onDeleteProject,
} from "../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import TableContainer from "components/Common/TableContainer";

import leaderboard from "../../common/data/leaderboard.csv"
import * as Papa from 'papaparse';




const ProjectStatus = ({ status }) => {
  switch (status) {
    case "Pending":
      return <Badge className="bg-warning"> {status} </Badge>;

    case "Delay":
      return <Badge className="bg-danger"> {status} </Badge>;

    case "Completed":
      return <Badge className="bg-success"> {status} </Badge>;

    default:
      return <Badge className="bg-success"> {status} </Badge>;
  }
};

const ProjectsList = () => {

  //meta title
  document.title = "Project List | Skote - React Admin & Dashboard Template";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [project, setProject] = useState();
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: (project && project.id) || "",
      img: (project && project.img) || "",
      name: (project && project.name) || "",
      description: (project && project.description) || "",
      status: (project && project.status) || "",
      color: (project && project.color) || "",
      dueDate: (project && project.dueDate) || "",
      team: (project && project.team) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(
        "Please Enter Your Name"
      ),
      description: Yup.string().required(
        "Please Enter Your Description"
      ),
      status: Yup.string().required(
        "Please Enter Your Status"
      ),
      color: Yup.string().required(
        "Please Enter Your Color"
      ),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateProject = {
          id: project.id,
          img: values.img,
          name: values.name,
          description: values.description,
          status: values.status,
          color: values.color,
          dueDate: values.dueDate,
          team: values.team,
        };

        // update project
        dispatch(onUpdateProject(updateProject));
      } else {
        const newProject = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          name: values["name"],
          description: values["description"],
          status: values["status"],
          color: values["color"],
          dueDate: values["dueDate"],
          team: values["team"],
        };
        // save new project
        dispatch(onAddNewProject(newProject));
      }
      toggle();
    },
  });


  /*
  const ProjectsProjectProperties = createSelector(
    (state) => state.projects,
    (Projects) => ({
      projects: Projects?.projects,
      loading: Projects?.loading
    })
  );

  const { projects, loading } = useSelector(ProjectsProjectProperties);
  */

  const [projects, setProjects] = useState([]);

  const [isLoading, setLoading] = useState(false)
  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [projectdata, setProjectData] = useState([]);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setProject(null);
    } else {
      setModal(true);
    }
  };


  const handleProjectClick = arg => {
    const project = arg;

    setProject({
      id: project.id,
      img: project.img,
      name: project.name,
      description: project.description,
      status: project.status,
      color: project.color,
      dueDate: project.dueDate,
      team: project.team,
    });

    setIsEdit(true);

    toggle();
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (project) => {

  };

  const handleDeleteOrder = () => {

  };



  useEffect(() => {
    //setProjects(projectdata)
    //console.log('project data', projectdata);
    console.log('leaderboard ', leaderboard);
    fetch( leaderboard )
    .then( response => response.text() )
    .then( responseText => {
      //console.log('response text ', responseText);
      var data = Papa.parse(responseText, {
        header: true
      });
      console.log('data:', data);
      setProjects(data.data);
      setProjectData(data.data);
    });

  }, []);

  const columns = useMemo(
    () => [
      {
        header: "#",
        id: "#",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Model Name',
        accessorKey: 'Model Name',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Publisher',
        accessorKey: 'Publisher',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Open Source',
        accessorKey: 'Open?',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Chatbot Arena Elo',
        accessorKey: 'Chatbot Arena Elo',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'HellaSwag (few-shot)',
        accessorKey: 'HellaSwag (few-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'HellaSwag (zero-shot)',
        accessorKey: 'HellaSwag (zero-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'HellaSwag (one-shot)',
        accessorKey: 'HellaSwag (one-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'HumanEval-Python (pass@1)',
        accessorKey: 'HumanEval-Python (pass@1)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'LAMBADA (zero-shot)',
        accessorKey: 'LAMBADA (zero-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'LAMBADA (one-shot)',
        accessorKey: 'LAMBADA (one-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'MMLU (zero-shot)',
        accessorKey: 'MMLU (zero-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'MMLU (one-shot)',
        accessorKey: 'MMLU (one-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: 'TriviaQA (zero-shot)',
        accessorKey: 'TriviaQA (zero-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'TriviaQA (one-shot)',
        accessorKey: 'TriviaQA (one-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'WinoGrande (zero-shot)',
        accessorKey: 'WinoGrande (zero-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'WinoGrande (one-shot)',
        accessorKey: 'WinoGrande (one-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'WinoGrande (few-shot)',
        accessorKey: 'WinoGrande (few-shot)',
        enableColumnFilter: false,
        enableSorting: true,
      },

    ],
    [
      handleProjectClick, onClickDelete
    ]
  );

  const handleProjectClicks = () => {
    navigate("/projects-create")
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Openrating.io" breadcrumbItem="Open Source LLM Ratings" />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle className="h4">Dear Open Source Enthusiasts</CardTitle>
                  <p className="card-title-desc">
                    We are thrilled to announce the launch of OpenRating.io, a pioneering initiative that aims to revolutionize the way we evaluate and appreciate open source language models (LLMs). In the fast-evolving landscape of artificial intelligence, language models play a pivotal role, and we believe in the power of community-driven feedback to shape their development
                  </p>


                  <p className="h6">Why OpenRating.io?</p>
                  <p>OpenRating.io was born out of the recognition that open source language models, such as llama 2, are crucial assets for developers, researchers, and businesses across the globe. However, assessing the quality, performance, and reliability of these models can be a daunting task. To address this challenge, we have created a platform that empowers the open source community to collaboratively rate and review LLMs.</p>

                  <p className="h6">1. Community-Driven Ratings:</p>
                  <p>OpenRating.io relies on the collective intelligence of the open source community. Developers, researchers, and users alike can contribute their insights and experiences, providing a diverse and comprehensive perspective on the strengths and weaknesses of various language models.</p>

                  <p className="h6">2. Transparent Metrics:</p>
                  <p>We believe in transparency. OpenRating.io provides clear and concise metrics to help users understand the strengths and weaknesses of different language models. These metrics are not just numbers but insights derived from real-world usage and evaluation.</p>
                  <p className="h6">3. Open Source Philosophy:</p>
                  <p>Following the principles of open source, OpenRating.io itself is an open project. Anyone can contribute to its development, suggest improvements, and collaborate to enhance its functionality. We encourage the community to actively participate in shaping the future of language model evaluations.</p>
                  <p className="h6">4. User-Friendly Interface:</p>
                  <p>Our platform features an intuitive and user-friendly interface, making it easy for both experts and newcomers to contribute their ratings and reviews. We aim to democratize the rating process, ensuring that everyone's voice is heard.</p>
                  <br />
                  <p className="h6">How to Get Involved:</p>
                  <p>OpenRating.io is only as powerful as the community that supports it. To get involved, simply visit our website and start exploring the various language models listed. Contribute your ratings, leave reviews, and engage in discussions with fellow users. Together, let's build a valuable resource for the entire open source community.</p>
                  <p className="h6">Join Us on the Journey:</p>
                  <p>OpenRating.io is more than just a platform; it's a community-driven movement to enhance the quality and accessibility of open source language models. Join us on this exciting journey, and let's collectively shape the future of language model evaluations.</p>
                  <p>Visit OpenRating.io today and be part of the revolution!</p>

                  <p>Happy coding,</p>

                  <p>The OpenRating.io Team</p>


                </CardBody>
              </Card>
            </Col>
          </Row>


          {
            isLoading ? <Spinners setLoading={setLoading} /> :
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <TableContainer
                        columns={columns}
                        data={projectdata}
                        isGlobalFilter={false}
                        isAddButton={false}
                        isPagination={false}
                        isCustomPageSize={true}
                        handleUserClick={handleProjectClicks}
                        SearchPlaceholder="9 records..."
                        buttonClass="btn btn-success btn-rounded"
                        buttonName=""
                        tableClass="project-list-table align-middle table-nowrap dt-responsive nowrap w-100 table-borderless dataTable no-footer dtr-inline"
                        theadClass="table-light"
                        paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                        pagination="pagination"
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
          }
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Project" : "Add Project"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col xs={12}>
                    <Input
                      type="hidden"
                      value={validation.values.img || ""}
                      name="img"
                    />

                    <Input
                      type="hidden"
                      value={validation.values.team || ""}
                      name="team"
                    />
                    <div className="mb-3">
                      <Label>Name</Label>
                      <Input
                        name="name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.name || ""}
                        invalid={
                          validation.touched.name && validation.errors.name ? true : false
                        }
                      />
                      {validation.touched.name && validation.errors.name ? (
                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label>Description</Label>
                      <Input
                        name="description"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.description || ""}
                        invalid={
                          validation.touched.description && validation.errors.description ? true : false
                        }
                      />
                      {validation.touched.description && validation.errors.description ? (
                        <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label>Status</Label>
                      <Input
                        name="status"
                        id="status1"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={
                          validation.values.status || ""
                        }
                      >
                        <option>Completed</option>
                        <option>Pending</option>
                        <option>Delay</option>
                      </Input>
                      {validation.touched.status && validation.errors.status ? (
                        <FormFeedback type="invalid">{validation.errors.status}</FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label>Color</Label>
                      <Input
                        name="color"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.color || ""}
                        invalid={
                          validation.touched.color && validation.errors.color ? true : false
                        }
                      >
                        <option>success</option>
                        <option>warning</option>
                        <option>danger</option>
                      </Input>
                      {validation.touched.color && validation.errors.color ? (
                        <FormFeedback type="invalid">{validation.errors.color}</FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label>dueDate</Label>
                      <FlatPickr
                        className="form-control"
                        name="dueDate"
                        options={{
                          dateFormat: "d M,Y"
                        }}
                        value={validation.values.dueDate || ""}
                        onChange={(date) => validation.setFieldValue("dueDate", moment(date[0]).format("DD MMMM, YYYY"))}
                      />
                      {validation.touched.dueDate && validation.errors.dueDate ? (
                        <FormFeedback type="invalid" className="d-block">{validation.errors.dueDate}</FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      <Button color="success"
                        type="submit"
                        className="save-user"
                      >
                        Save
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment >
  );
};

export default withRouter(ProjectsList);
